import React from "react";
import PropTypes from "prop-types";
import entete from "../../../../assets/img/entete.jpg";
import { DocumentFooter } from "../../../../components/docs/DocumentFooter";

const border = "1px solid #333";
const th = { border, padding: "6px 8px", fontSize: 11, background: "#dbe5f1", textAlign: "center" };
const td = { border, padding: "5px 8px", fontSize: 11 };
const tdC = { ...td, textAlign: "center" };

const pageStyle = {
    width: "210mm",
    minHeight: "297mm",
    padding: "12mm",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
};

/**
 * État des contrats IMPRIMÉS sur une période — format habituel (en-tête entete.jpg + DocumentFooter).
 * Reçoit la liste déjà filtrée/mappée (numeroPolice, souscripteur, immatriculation, organisme,
 * dateEffet, dateEcheance, regle) et le libellé de période.
 */
const EtatContratsImprimes = React.forwardRef((props, ref) => {
    const contrats = props.contrats || [];
    const periode = props.periode || "";

    return (
        <div ref={ref}>
            <div style={pageStyle}>
                <div style={{ flexShrink: 0 }}>
                    <img src={entete} alt="" style={{ width: "100%", maxHeight: 110, objectFit: "contain" }} />
                    <h3 style={{ textAlign: "center", color: "#272366", margin: "10px 0 2px" }}>
                        ÉTAT DES CONTRATS IMPRIMÉS
                    </h3>
                    {periode && (
                        <div style={{ textAlign: "center", fontSize: 12, marginBottom: 8 }}>{periode}</div>
                    )}
                </div>

                <div style={{ flex: 1 }}>
                    {contrats.length === 0 ? (
                        <p style={{ marginTop: 24 }}>Aucun contrat imprimé sur la période sélectionnée.</p>
                    ) : (
                        <table style={{ width: "100%", borderCollapse: "collapse" }}>
                            <thead>
                                <tr>
                                    <th style={{ ...th, width: 32 }}>N°</th>
                                    <th style={th}>N° Police</th>
                                    <th style={th}>Souscripteur</th>
                                    <th style={th}>Immatriculation</th>
                                    <th style={th}>Compagnie</th>
                                    <th style={th}>Date effet</th>
                                    <th style={th}>Date échéance</th>
                                    <th style={th}>Statut</th>
                                </tr>
                            </thead>
                            <tbody>
                                {contrats.map((c, i) => (
                                    <tr key={c.codeId || i}>
                                        <td style={tdC}>{i + 1}</td>
                                        <td style={td}>{c.numeroPolice || "—"}</td>
                                        <td style={td}>{c.souscripteur || "—"}</td>
                                        <td style={td}>{c.immatriculation || "—"}</td>
                                        <td style={td}>{c.organisme || "—"}</td>
                                        <td style={tdC}>{c.dateEffet || "—"}</td>
                                        <td style={tdC}>{c.dateEcheance || "—"}</td>
                                        <td style={tdC}>{c.regle === "REGLE" ? "Réglé" : "Non réglé"}</td>
                                    </tr>
                                ))}
                                <tr style={{ fontWeight: 700, background: "#e2efda" }}>
                                    <td style={tdC} colSpan={7}>TOTAL CONTRATS IMPRIMÉS</td>
                                    <td style={tdC}>{contrats.length}</td>
                                </tr>
                            </tbody>
                        </table>
                    )}
                </div>

                <DocumentFooter />
            </div>
        </div>
    );
});

EtatContratsImprimes.displayName = "EtatContratsImprimes";
EtatContratsImprimes.propTypes = {
    contrats: PropTypes.array,
    periode: PropTypes.string,
};

export default EtatContratsImprimes;
